import { useMemo } from 'react'

const isValidHexColor = (hexColor: string) => /^#([a-f0-9]{3,4}|[a-f0-9]{4}(?:[a-f0-9]{2}){1,2})\b$/i.test(hexColor)

type UseHdgwIframeParamsProps = Readonly<{
  locale?: string
  primaryColor?: string
  redirectUrl?: string
}>

export const useHdgwIframeParams = ({ locale, primaryColor, redirectUrl }: UseHdgwIframeParamsProps = {}) =>
  useMemo(() => {
    const params = new URLSearchParams({
      showFooter: 'false',
      showTermsWhenAccount: 'false',
      displayMode: 'widget',
      redirectPlatform: 'wpg'
    })

    if (locale) {
      params.set('locale', locale)
    }

    if (primaryColor && isValidHexColor(primaryColor)) {
      params.set('primaryColor', primaryColor)
    }

    if (redirectUrl) {
      params.set('redirectUrl', redirectUrl)
    }

    return params
  }, [locale, primaryColor, redirectUrl])
